//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { IIssue } from "Application/features/models/Issue/IIssue";
import { queryResponse, sibaReportApi } from "../../backends/sibaApis";
import { userManagementUtil } from "@siba/utilities";

const api = "api/Issue";
/***
 * Service definition for Report setup
 *  */
const ReportApi = sibaReportApi.injectEndpoints({
    endpoints: (builder) => ({
        /**
         * Save  endpoint
         *
         */
        saveReport: builder.mutation<queryResponse<any>, IIssue[]>({
            query: (obj: IIssue[]) => ({
                url: `${api}`,
                method: "POST",
                //body: obj,
                data: obj
            })
        }),

        /**
         * Update  endpoint
         * query expects object of type country model.
         * id field is destructure and passed as a query parameter.
         */
        updateReport: builder.mutation<queryResponse<number>, IIssue>({
            query: ({ id, ...rest }: any) => ({
                url: `${api}/${id}`,
                method: "PUT",
                // body: { ${}id, ...rest },
                data: { id, ...rest }
            })
        }),
        /**
         * Remove  endpoint
         * query expects object with parameters id and modified by (string).
         * id and modifiedby propertied destructured and passed as a query parameter.
         */
        removeReport: builder.mutation<queryResponse<number>, IIssue>({
            query: ({ id, modifiedBy }: any) => ({
                url: `${api}/${id}/${modifiedBy}`,
                method: "DELETE"
            })
        }),
        /**
         * Sample query method using rtk mutation instead of rtk query.
         */
        getAllReport: builder.mutation<IIssue[], void>({
            query: () => ({
                url: `${api}`,
                method: "GET"
            })
        }),
        /***
         *  Search  Endpoint
         *  using rtk mutations instead of rtk for search.
         * @param query search form object of type ISearchForm.
         */
        searchReport: builder.mutation<queryResponse<IIssue[]>, any>({
            query: (query: any) => ({
                url: `${api}/search`,
                method: "POST",
                // body: query,
                data: query
            })
        }),

        /***
         *  Search  Endpoint
         *  using rtk mutations instead of rtk for search.
         * @param query search form object of type ISearchForm.
         */
        searchReportByFilter: builder.mutation<queryResponse<IIssue[]>, any>({
            query: (query) => ({
                url: `${api}/filter/search`,
                method: "POST",
                // body: query,
                data: { ...query, organisationId: userManagementUtil.getUserSession().companyName == "SIBA" ? null : userManagementUtil.getUserSession().companyId }
            })
        }),
        /***
         *  Search  Endpoint
         *  using rtk mutations instead of rtk for search.
         * @param query search form object of type ISearchForm.
         */
        filterSearchWithSteps: builder.mutation<queryResponse<IIssue[]>, { query: string; index: number }>({
            query: ({ query, index }) => ({
                url: `${api}/filter/${query}/${index}`,
                method: "GET"
            })
        }),

        /**
         * Sample query method using rtk mutation instead of rtk query.
         */
        getReport: builder.mutation<IIssue[], void>({
            query: () => ({
                url: `${api}/lov`,
                method: "GET"
            })
        }),

        /**
         * Get all Report by Employee Id mutation query.
         */
        getReportById: builder.mutation<IIssue[], string>({
            query: (id: string) => ({ url: `${api}/${id}`, method: "GET" })
        }),

        /**
         * Get all Report by Employee Id mutation query.
         */
        getRecentReportList: builder.mutation<IIssue[], null>({
            query: () => ({ url: `${api}/recent`, method: "GET" })
        }),

        /***
         *  Search  Endpoint
         *  using rtk mutations instead of rtk for search.
         * @param query search form object of type ISearchForm.
         */
        toggleReportState: builder.mutation<queryResponse<IIssue[]>, { data: IIssue[]; state: string | number }>({
            query: ({ data, state }) => ({
                url: `${api}/toggle/state/${state}`,
                method: "POST",
                // body: query,
                data: data
            })
        }),
        /***
         *  Search  Endpoint
         *  using rtk mutations instead of rtk for search.
         * @param query search form object of type ISearchForm.
         */
        searchConfirmedReports: builder.mutation<queryResponse<IIssue[]>, any>({
            query: (query: any) => ({
                url: `${api}/filter/search`,
                method: "POST",
                // body: query,
                data: { ...query, organisationId: userManagementUtil.getUserSession().companyName == "SIBA" ? null : userManagementUtil.getUserSession().companyId }
            })
        }),
        /**
         * Get all Report by Employee Id mutation query.
         */
        getPendingReview: builder.mutation<IIssue[], void>({
            query: (query: any) => ({
                url: `${api}/pending`,
                method: "POST",
                // body: query,
                data: query
            })
        })
    })
});

export const {
    useSaveReportMutation,
    useUpdateReportMutation,
    useRemoveReportMutation,
    useSearchReportMutation,
    useSearchReportByFilterMutation,
    useGetReportByIdMutation,
    useFilterSearchWithStepsMutation,
    useGetRecentReportListMutation,
    useToggleReportStateMutation,
    useSearchConfirmedReportsMutation,
    useGetPendingReviewMutation,
    useGetAllReportMutation
} = ReportApi;
